import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=23fb6c2c&scoped=true&"
import script from "./comments.vue?vue&type=script&lang=js&"
export * from "./comments.vue?vue&type=script&lang=js&"
import style0 from "./comments.vue?vue&type=style&index=0&id=23fb6c2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fb6c2c",
  null
  
)

export default component.exports